import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-has-sub-products-toggle',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './has-sub-products-toggle.html',
    styleUrl: './has-sub-products-toggle.scss',
})
export class HasSubProductsToggle {
  value = input.required<boolean>();
  toggle = output<boolean>();

  onChange(event: Event): void {
    const val = (event.target as HTMLInputElement).checked;
    this.toggle.emit(val);
  }
}
